import React, { useState } from "react";
import { ReportLayout } from "../../../components/ReportLayout/ReportLayout";
import Header from "./components/Header/Header";
import { Box } from "../../../../../shared/Box/Box";
import { useReport } from "./hooks/useReport";
import { TableHeading } from "./components/TableHeading/TableHeading";
import { Table } from "./components/Table/Table";
import VerticalsReportDetails from "./StaticReports/VerticalsReportDetails/VerticalReportDetails";

const VerticalsUsageReport = () => {
  const { data, period, order, isLoading, clinic, download } = useReport();

  const [selectedRowView, setSelectedRowView] = useState(null);

  return (
    <ReportLayout>
      {!selectedRowView ? (
        <>
          <Header download={download} />
          <Box>
            <TableHeading period={period} clinic={clinic} download={download} />
            <Table
              report={data}
              order={order}
              isLoading={isLoading}
              handleRowClick={(row) => setSelectedRowView(row)}
            />
          </Box>
        </>
      ) : (
        <VerticalsReportDetails
          selectedRowView={selectedRowView}
          setSelectedRowView={setSelectedRowView}
          period={period}
        />
      )}
    </ReportLayout>
  );
};

export default VerticalsUsageReport;
